import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { webappRoute } from "./layout"

export const todayRoute = createRoute({
  getParentRoute: () => webappRoute,
  path: "/today",
  component: lazyRouteComponent(() => import("./lazy-pages"), "TodayPage"),
})
